export const TeamSettings = 'TeamSettings'
export const ManageChannelsPermissions = 'ManageChannelsPermissions'
export const ManageWhoCanInvite = 'ManageWhoCanInvite'
export const CreateUserGroups = 'CreateUserGroups'
export const ManageDefaultRole = 'ManageDefaultRole'
export const googleSSO = 'googleSSO'
export const AutomaticBackup = 'AutomaticBackup'
export const DisplayNotesActivity = 'DisplayNotesActivity'
export const DisplayNotesHistory = 'DisplayNotesHistory'
export const ManagePublicChannels = 'ManagePublicChannels'
export const ManagePublicNotes = 'ManagePublicNotes'
export const NotesLimit = 'NotesLimit'
